// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__o5Dfi","content":"LayoutSettings_content__2wHpV"};